import React, { Component, Fragment } from 'react';
import { Col, Form } from 'react-bootstrap';
import Header from '../../../global_components/Header';
import { getValueFromInputData } from '../../../helpers/objects';
import { states, provinces } from '../../../assets/objects';
import RequiredLabel from '../../../global_components/RequiredLabel';
import { IMaskInput } from 'react-imask';

export class ThirdPartyPayer extends Component {
	constructor(props) {
		super(props);
		this.organizationInput = React.createRef();
	}
	componentDidMount() {
		this.organizationInput.current.focus();
	}
	renderStateOrProvinceOptions = () => {
		const { business } = this.props;
		if (business.is_canadian) {
			const provincesArray = Object.keys(provinces);
			return provincesArray.map(province => {
				return <option value={ province } key={ province }>{ provinces[province] }</option>;
			});
		} else {
			const statesArray = Object.keys(states);
			return statesArray.map(state => {
				return <option value={ state } key={ state }>{ states[state] }</option>;
			});
		}
	};
	render() {
		const { inputData, business } = this.props;
		return (
			<Fragment>
				<Header head="Third party payer" subHead="So you're not responsible for payment, who is?" />
				<div>
					<Form>
						<Form.Row>
							<Col>
								<Form.Label className="label">Organization</Form.Label>
								<Form.Control ref={ this.organizationInput } size="sm" defaultValue={ getValueFromInputData(inputData, 'payer-organization') } name="payer-organization" onChange={ (event) => { this.props.inputChange({ event }); } } />
							</Col>
						</Form.Row>
						<Form.Row>
							<Col>
								<Form.Label className="label">First name <RequiredLabel /></Form.Label>
								<Form.Control size="sm" defaultValue={ getValueFromInputData(inputData, 'payer-first') } name="payer-first" onChange={ (event) => { this.props.inputChange({ event }); } } maxLength="50"/>
							</Col>
							<Col>
								<Form.Label className="label">Last name <RequiredLabel /></Form.Label>
								<Form.Control size="sm" defaultValue={ getValueFromInputData(inputData, 'payer-last') } name="payer-last" onChange={ (event) => { this.props.inputChange({ event }); } } maxLength="50" />
							</Col>
						</Form.Row>
						<Form.Row>
							<Col>
								<Form.Label className="label">Email address <RequiredLabel /></Form.Label>
								<Form.Control size="sm" defaultValue={ getValueFromInputData(inputData, 'payer-email') } name="payer-email" onChange={ (event) => { this.props.inputChange({ event }); } } />
							</Col>
							<Col>
								<Form.Label className="label">Address <RequiredLabel /></Form.Label>
								<Form.Control size="sm" defaultValue={ getValueFromInputData(inputData, 'payer-address') } name="payer-address" onChange={ (event) => { this.props.inputChange({ event }); } } />
							</Col>
						</Form.Row>
						<Form.Row>
							<Col>
								<Form.Label className="label">City <RequiredLabel /></Form.Label>
								<Form.Control size="sm" defaultValue={ getValueFromInputData(inputData, 'payer-city') } name="payer-city" onChange={ (event) => { this.props.inputChange({ event }); } } maxLength="50" />
							</Col>
							<Col>
								<Form.Label className="label">{ business.is_canadian ? 'Province' : 'State' } <RequiredLabel /></Form.Label>
								<Form.Control size="sm" as="select" defaultValue={ getValueFromInputData(inputData, 'payer-state') } name="payer-state" onChange={ (event) => { this.props.inputChange({ event }); } } >
									<option disabled value="default">Select { business.is_canadian ? 'province' : 'state' }</option>
									{ this.renderStateOrProvinceOptions() }
								</Form.Control>
							</Col>
						</Form.Row>
						<Form.Row>
							<Col>
								<Form.Label className="label">{business.is_canadian ? 'Postal code' : 'Zip code'} < RequiredLabel /></Form.Label>
								{/* <Form.Control size="sm" defaultValue={ getValueFromInputData(inputData, 'payer-zip_postal') } name="payer-zip_postal" onChange={ (event) => { this.props.inputChange({ event }); } } as={ InputMask } mask={business.is_canadian ? 'a9a9a9' : '99999'} /> */}
								<IMaskInput
									mask={business.is_canadian ? 'a0a 0a0' : '00000'}
									defaultValue={ getValueFromInputData(inputData, 'payer-zip_postal') }
									name="payer-zip_postal"
									unmask={true}
									onAccept={(value) => {
										this.props.inputChange({ otherValue: value, otherName: 'payer-zip_postal' });
									}}
									className='form-control form-control-sm'
								/>
							</Col>
						</Form.Row>
						<Form.Row>
							<Col>
								<Form.Label className="label">Phone 1 <RequiredLabel /></Form.Label>
								{/* <Form.Control as={ InputMask } mask="(999) 999-9999" size="sm" defaultValue={ getValueFromInputData(inputData, 'payer-phone1') } name="payer-phone1" onChange={ (event) => { this.props.inputChange({ event }); } } /> */}
								<IMaskInput
									mask="(000) 000-0000"
									defaultValue={ getValueFromInputData(inputData, 'payer-phone1') }
									name="payer-phone1"
									unmask={true}
									onAccept={(value) => {
										this.props.inputChange({ otherValue: value, otherName: 'payer-phone1' });
									}}
									className='form-control form-control-sm'
								/>
							</Col>
							<Col>
								<Form.Label className="label">Phone 2</Form.Label>
								{/* <Form.Control as={ InputMask } mask="(999) 999-9999" size="sm" defaultValue={ getValueFromInputData(inputData, 'payer-phone2') } name="payer-phone2" onChange={ (event) => { this.props.inputChange({ event }); } } /> */}
								<IMaskInput
									mask="(000) 000-0000"
									defaultValue={ getValueFromInputData(inputData, 'payer-phone2') }
									name="payer-phone2"
									unmask={true}
									onAccept={(value) => {
										this.props.inputChange({ otherValue: value, otherName: 'payer-phone2' });
									}}
									className='form-control form-control-sm'
								/>
							</Col>
						</Form.Row>
					</Form>
				</div>
			</Fragment>
		);
	}
}

export default ThirdPartyPayer;
